(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-swatches"] && !Shopify.designMode) return;
  try {
    var moreSwatchCount = document.querySelectorAll(
    'div[data-id="{{ card_product.id }}"] .card-product-swatch-link.hidden'
  ).length;
  if (moreSwatchCount > 0) {
    var moreSwatchCountElement = document.querySelector(
      'div[data-id="{{ card_product.id }}"] .card-product-swatch-more'
    );
    moreSwatchCountElement.textContent = '+' + moreSwatchCount;
    moreSwatchCountElement.classList.remove('hidden');
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block-discount-code"] && !Shopify.designMode) return;
  try {
    (function () {
    function showCopiedState(button) {
      var label = button.querySelector('[data-discount-code-text]');
      if (!label) return;
      var original = label.textContent;
      label.textContent = 'Copied!';
      setTimeout(function () {
        label.textContent = original;
      }, 1500);
    }

    function fallbackCopy(text) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      var success = false;
      try {
        success = document.execCommand('copy');
      } catch (e) {
        success = false;
      }
      document.body.removeChild(textarea);
      return success;
    }

    var button = document.querySelector('[data-discount-code]');
    if (!button) return;

    button.addEventListener('click', function () {
      var code = button.getAttribute('data-discount-code');
      if (!code) return;

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(function () {
          showCopiedState(button);
        });
        return;
      }

      if (fallbackCopy(code)) {
        showCopiedState(button);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky-atc"] && !Shopify.designMode) return;
  try {
    window.addEventListener("scroll", function() {
    // The main product information section (cannot be removed from template)
    let productPage = document.querySelector('[id$="__main"]');
    let stickyAtc = document.querySelector('.product-sticky-atc');
    if (window.scrollY > (productPage.offsetTop + productPage.offsetHeight)) {
      stickyAtc.classList.remove('hidden');
    } else {
      stickyAtc.classList.add('hidden');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
